'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _rcRate = require('rc-rate');

var _rcRate2 = _interopRequireDefault(_rcRate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_Node = require('react').babelPluginFlowReactPropTypes_proptype_Node || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var outlineAction = {
  NOACTION: 0,
  CLICK: 1,
  CHANGE: 2,
  BLUR: 3
};

var Rating = function (_Component) {
  _inherits(Rating, _Component);

  function Rating(props) {
    _classCallCheck(this, Rating);

    var _this = _possibleConstructorReturn(this, (Rating.__proto__ || Object.getPrototypeOf(Rating)).call(this, props));

    _this.initRate = function (node) {
      _this.rcRate = node;
    };

    _this.onMouseDown = function () {
      _this.setState({
        hasOutLine: false,
        lastAction: outlineAction.CLICK
      });
    };

    _this.onBlur = function () {
      var lastAction = _this.state.lastAction;

      if (lastAction === outlineAction.CLICK) {
        _this.setState({
          hasOutLine: false,
          lastAction: outlineAction.BLUR
        });
      } else {
        _this.setState({
          hasOutLine: true,
          lastAction: outlineAction.BLUR
        });
      }
    };

    _this.onChange = function (value) {
      _this.props.onChange && _this.props.onChange(value);
      _this.setState({
        lastAction: outlineAction.CHANGE
      });
    };

    _this.state = {
      hasOutLine: true,
      lastAction: outlineAction.NOACTION
    };
    return _this;
  }

  _createClass(Rating, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          style = _props.style,
          className = _props.className,
          _props$size = _props.size,
          size = _props$size === undefined ? 'lg' : _props$size,
          otherProps = _objectWithoutProperties(_props, ['style', 'className', 'size']);

      var classes = (0, _classnames3.default)(className, (_classnames = {
        'a-rating': true
      }, _defineProperty(_classnames, 'a-rating-' + size, true), _defineProperty(_classnames, 'a-rating-no-outline-click', !this.state.hasOutLine), _classnames));
      //Fix default value bug
      var defaultValue = void 0;
      if (this.props.defaultValue === true) {
        defaultValue = 0;
      } else {
        defaultValue = this.props.defaultValue;
      }
      return _react2.default.createElement(
        'div',
        {
          style: style,
          className: classes,
          onMouseDown: this.onMouseDown,
          onBlur: this.onBlur
        },
        _react2.default.createElement(_rcRate2.default, Object.assign({
          ref: this.initRate
        }, otherProps, {
          onChange: this.onChange,
          defaultValue: defaultValue
        }))
      );
    }
  }]);

  return Rating;
}(_react.Component);

Rating.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['sm', 'lg']),
  count: _propTypes2.default.number,
  value: _propTypes2.default.number,
  defaultValue: _propTypes2.default.number,
  allowHalf: _propTypes2.default.bool,
  allowClear: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onHoverChange: _propTypes2.default.func,
  character: _propTypes2.default.node
};

Rating.displayName = 'Rating';

exports.default = Rating;